import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import myImg from "../../Assets/avatar.png";
// import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn, FaEnvelope } from "react-icons/fa";
// import { SiX } from "react-icons/si";

function Home2() {
  return (
    <Container
      fluid
      className="home-about-section"
      id="about"
      style={{ marginTop: 0 }}
    >
      <Container
        className="glass-card"
        style={{
          maxWidth: 950,
          borderRadius: 24,
          boxShadow: "0 8px 32px 0 rgba(80,120,200,0.10)",
          padding: "2.5rem 2rem",
          margin: "0 auto",
        }}
      >
        <Row>
          <Col md={7} xs={12} style={{ marginBottom: 24 }}>
            <h1
              style={{ fontSize: "2.1em", fontWeight: 700, marginBottom: 18 }}
            >
              The <span className="purple">Story So Far</span>
            </h1>
            <p
              className="home-about-body"
              style={{ fontSize: "1.13em", color: "#64748b", fontWeight: 500 }}
            >
              Started building <b className="purple">real-world projects</b>{" "}
              early on, combining <b className="purple">AI, Web3,</b> and{" "}
              <b className="purple">full-stack development</b>.<br />
              <br />
              Contributed to <b className="purple">
                9+ open-source programs
              </b>{" "}
              with <b className="purple">220+ merged PRs</b> and mentored in{" "}
              <b className="purple">4 OSS programs</b>, guiding{" "}
              <b className="purple">300+ developers</b> through code reviews and
              support.
              <br />
              <br />
              Secured multiple <b className="purple">internships</b> through
              open-source work, making meaningful{" "}
              <b className="purple">backend</b> and{" "}
              <b className="purple">system-level contributions</b>.<br />
              <br />
              Solved <b className="purple">1000+ DSA problems</b> while
              strengthening my foundation in{" "}
              <b className="purple">system design, DevOps,</b> and{" "}
              <b className="purple">modern frameworks</b>.<br />
              <br />
              Recognized in top developer programs like{" "}
              <b className="purple">C4GT, GSSoC</b> and{" "}
              <b className="purple">VSoC</b> for consistent impact and
              contributions.
            </p>
          </Col>
          <Col
            md={5}
            xs={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 24,
            }}
          >
            <h2
              style={{
                fontSize: "1.5em",
                fontWeight: 700,
                marginBottom: 16,
                color: "#2563eb",
              }}
            >
              Contact Me
            </h2>
            <Button
              variant="outline-primary"
              href="mailto:meetofficialhere@gmail.com"
              style={{
                fontWeight: 600,
                fontSize: "1.1em",
                borderRadius: 10,
                marginBottom: 10,
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "0.6em 1.5em",
                background: "rgba(96,165,250,0.08)",
                border: "1.5px solid #60a5fa",
                color: "#2563eb",
              }}
            >
              <FaEnvelope style={{ fontSize: 18 }} /> meetofficialhere@gmail.com
            </Button>
            <div style={{ display: "flex", gap: 18, marginTop: 8 }}>
              <a
                href="https://github.com/Meetjain1"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
                style={{ fontSize: 28 }}
              >
                <AiFillGithub />
              </a>
              {/* <a href="https://twitter.com/Meetjain_100" target="_blank" rel="noreferrer" className="icon-colour home-social-icons" style={{ fontSize: 28 }}>
                <SiX />
              </a> */}
              <a
                href="https://linkedin.com/in/meet-jain-413015265/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
                style={{ fontSize: 28 }}
              >
                <FaLinkedinIn />
              </a>
              {/* <a
                href="https://www.instagram.com/m.jain_17/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
                style={{ fontSize: 28 }}
              >
                <AiFillInstagram />
              </a> */}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
